import { User } from '../models/User';

/**
 * @deprecated
 */
export const dummyUser: User = {
  name: 'Johnny Boxes',
  school: 'Westside High School',
  email: 'johnny.boxes@email.com',
  preferredPronoun: 'he / him',
  photoUrl:
    'https://www.tinyboxcompany.co.uk/media/catalog/product/cache/1/image/85e4522595efc69f496374d01ef2bf13/F/M/FMKRCU_22.jpg',
  permissions: 'Admin,Dev,Student,Teacher,Counselor',
};
